import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { MapPin, Phone, Clock } from 'lucide-react';
import { restaurantInfo } from '../mock';

const Contact = ({ onReservationClick }) => {
  return (
    <section className="py-32 px-6 bg-background border-t border-border/40">
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-5xl md:text-6xl font-serif font-normal text-primary mb-24 text-center tracking-wide">
          Kapcsolat
        </h2>
        <div className="grid md:grid-cols-2 gap-16">
          <div className="space-y-12">
            <div className="space-y-8">
              <div className="flex items-start gap-6 group">
                <MapPin className="w-5 h-5 text-accent mt-1" />
                <div>
                  <p className="text-xs uppercase tracking-widest font-bold text-foreground mb-2">Cím</p>
                  <p className="text-muted-foreground font-light">{restaurantInfo.address}</p>
                </div>
              </div>
              <div className="flex items-start gap-6 group">
                <Phone className="w-5 h-5 text-accent mt-1" />
                <div>
                  <p className="text-xs uppercase tracking-widest font-bold text-foreground mb-2">Telefon</p>
                  <a href={`tel:${restaurantInfo.phone}`} className="text-muted-foreground font-light hover:text-foreground transition-colors">
                    {restaurantInfo.phone}
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-6 group">
                <Clock className="w-5 h-5 text-accent mt-1" />
                <div>
                  <p className="text-xs uppercase tracking-widest font-bold text-foreground mb-2">Nyitvatartás</p>
                  <p className="text-muted-foreground font-light">{restaurantInfo.openingDay}</p>
                </div>
              </div>
            </div>
            <Button 
              size="lg"
              className="w-full"
              onClick={onReservationClick}
            >
              Asztalfoglalás
            </Button>
          </div>
          
          <div className="h-[400px] bg-secondary/10 border border-border p-2">
             <iframe 
                width="100%" 
                height="100%" 
                frameBorder="0" 
                scrolling="no" 
                marginHeight="0" 
                marginWidth="0" 
                src={`https://maps.google.com/maps?q=${encodeURIComponent(restaurantInfo.address)}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
                className="transition-opacity duration-500"
             ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
